import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import adminApiClient from '../../api/adminAxios';

function AdminRestaurantDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setError('');
    adminApiClient
      .get(`/api/admin/restaurants/${id}`)
      .then((res) => setData(res.data))
      .catch((err) => setError(err.response?.status === 404 ? 'Restaurant not found.' : 'Failed to load.'))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="min-h-screen bg-slate-900 text-slate-100">
      <header className="border-b border-slate-800 px-6 py-4">
        <Link to="/iseeallnomisses/console" className="text-sm text-slate-400 hover:text-slate-100">
          ← Back to subscribers
        </Link>
      </header>

      <main className="p-6 max-w-4xl mx-auto">
        {loading && <p className="text-slate-500">Loading…</p>}
        {error && <p className="text-red-400">{error}</p>}

        {data && (
          <>
            <h1 className="text-xl font-semibold mb-1">{data.name}</h1>
            <p className="text-sm text-slate-400 mb-6">
              Tier: {data.tier || '—'} · State: {data.state} · Expires:{' '}
              {data.subscriptionExpiresAt ? data.subscriptionExpiresAt.replace('T', ' ') : 'never'}
            </p>

            <section className="grid grid-cols-2 gap-4 mb-8">
              <div className="rounded border border-slate-800 bg-slate-800/50 p-4">
                <p className="text-xs text-slate-400 mb-1">WhatsApp outbound (last 30 days)</p>
                <p className="text-2xl font-semibold">{data.whatsappOutboundCount}</p>
              </div>
              <div className="rounded border border-slate-800 bg-slate-800/50 p-4">
                <p className="text-xs text-slate-400 mb-1">WhatsApp inbound (last 30 days)</p>
                <p className="text-2xl font-semibold">{data.whatsappInboundCount}</p>
              </div>
            </section>
            {data.whatsappUsagePartial && (
              <p className="text-xs text-slate-500 -mt-6 mb-8">
                Partial count — some send paths aren't instrumented yet; treat as a lower bound.
              </p>
            )}

            <section className="mb-8">
              <h2 className="text-sm font-semibold text-slate-300 mb-3">Employees ({data.employees.length})</h2>
              <div className="overflow-x-auto rounded border border-slate-800">
                <table className="min-w-full text-sm">
                  <thead className="bg-slate-800 text-slate-400 text-left">
                    <tr>
                      <th className="px-3 py-2">Name</th>
                      <th className="px-3 py-2">Role</th>
                      <th className="px-3 py-2">Active</th>
                      <th className="px-3 py-2">WhatsApp opt-in</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.employees.map((e) => (
                      <tr key={e.id} className="border-t border-slate-800">
                        <td className="px-3 py-2">{e.name}</td>
                        <td className="px-3 py-2 text-slate-400">{e.jobRole}</td>
                        <td className="px-3 py-2">{e.isActive ? 'Yes' : 'No'}</td>
                        <td className="px-3 py-2 text-slate-400">{e.whatsappOptinStatus}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>

            <section>
              <h2 className="text-sm font-semibold text-slate-300 mb-3">Recent activity</h2>
              <ul className="space-y-1.5">
                {data.activity.length === 0 && <li className="text-sm text-slate-500">No recent activity.</li>}
                {data.activity.map((a, i) => (
                  <li key={i} className="text-sm flex gap-3">
                    <span className="text-slate-500 shrink-0 w-40">
                      {a.timestamp ? a.timestamp.replace('T', ' ').slice(0, 19) : ''}
                    </span>
                    <span className="text-slate-400 shrink-0 w-32">{a.type}</span>
                    <span className="text-slate-200">{a.description}</span>
                  </li>
                ))}
              </ul>
            </section>
          </>
        )}
      </main>
    </div>
  );
}

export default AdminRestaurantDetail;
